import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ScrollToTop from "@/components/ScrollToTop";
import PageMeta from "@/components/PageMeta";
import GoogleAnalytics from "@/components/GoogleAnalytics";
import Home from "@/pages/Home";

const Services = lazy(() => import("@/pages/Services"));
const HowItWorks = lazy(() => import("@/pages/HowItWorks"));
const About = lazy(() => import("@/pages/About"));
const ForFamilies = lazy(() => import("@/pages/ForFamilies"));
const WorkWithUs = lazy(() => import("@/pages/WorkWithUs"));
const Contact = lazy(() => import("@/pages/Contact"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const SeoLanding = lazy(() => import("@/pages/SeoLanding"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <BrowserRouter>
        <PageMeta />
        <GoogleAnalytics />
        <ScrollToTop />
        <div className="flex flex-col min-h-screen">
          <Header />
          <div className="flex-1">
            <Suspense fallback={<div className="min-h-[50vh] flex items-center justify-center" aria-busy="true" />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/servicos" element={<Services />} />
              <Route path="/como-funciona" element={<HowItWorks />} />
              <Route path="/sobre" element={<About />} />
              <Route path="/para-familias" element={<ForFamilies />} />
              <Route path="/trabalhe-conosco" element={<WorkWithUs />} />
              <Route path="/contato" element={<Contact />} />
              <Route path="/privacidade" element={<Privacy />} />
              <Route path="/cuidador-de-idosos-rj" element={<SeoLanding />} />
              <Route path="/home-care-rio-de-janeiro" element={<SeoLanding />} />
              <Route path="/acompanhamento-hospitalar-rj" element={<SeoLanding />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            </Suspense>
          </div>
          <Footer />
          <WhatsAppButton />
        </div>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
